import { render, staticRenderFns } from "./Forca.vue?vue&type=template&id=323ce8a4&scoped=true&"
import script from "./Forca.vue?vue&type=script&lang=js&"
export * from "./Forca.vue?vue&type=script&lang=js&"
import style0 from "./Forca.vue?vue&type=style&index=0&id=323ce8a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323ce8a4",
  null
  
)

export default component.exports